export default __webpack_public_path__ + "static/media/29.e80b1371.jpg";